<div class="d-flex">
  <div class="col-12 d-flex flex-column justify-content-center align-items-center mb-2 py-3 has-outline-menu">
    <h1 class="vs-text-purple fw-bold text-center m-0"> Meta Data </h1>
  </div>
</div>
<div class="seo-section has-outline-menu">
  <div class="vs-crud-menu">
    <button type="button" [disabled]="!mantenienceMedata" [ngClass]="mantenienceMedata ? 'vs-btn-crud' : 'vs-btn-crud-disabled'" matTooltip="Editar Meta Data" (click)="editMetaData(metaData)">
      <mat-icon>edit</mat-icon>
    </button>
  </div>
  <div>
    <h4 class="fw-bold m-0">Título:</h4>
    <p>{{metaData.name}}</p>
  </div>
  <div>
    <h4 class="fw-bold m-0">Descripción :</h4>
    <p>{{metaData.description}}</p>
  </div>
  <div>
    <h4 class="fw-bold m-0">Keywords (Palabras clave) :</h4>
    <mat-chip-list>
      <mat-chip
        *ngFor="let tag of metaData.detail">
        {{tag.title}}
      </mat-chip>
    </mat-chip-list>
  </div>
</div>
